import type { LeadConversionAdapter } from "../contracts";
import { createDeliveryResult } from "../contracts";

export const metaPixelLeadAdapter: LeadConversionAdapter = {
  id: "meta-pixel",
  async trackLead(event) {
    if (event.consent.advertising === "denied") {
      return createDeliveryResult({
        provider: this.id,
        channel: "browser",
        eventName: "Lead",
        status: "skipped",
        eventId: event.conversionEventId,
        reason: "advertising_consent_denied",
      });
    }

    if (typeof window.fbq !== "function") {
      return createDeliveryResult({
        provider: this.id,
        channel: "browser",
        eventName: "Lead",
        status: "failed",
        eventId: event.conversionEventId,
        reason: "pixel_unavailable",
      });
    }

    window.fbq("track", "Lead", {}, { eventID: event.conversionEventId });
    return createDeliveryResult({
      provider: this.id,
      channel: "browser",
      eventName: "Lead",
      status: "sent",
      eventId: event.conversionEventId,
    });
  },
};
